export const showSpinner = ({ commit }, spinner) => {
  commit("SHOW_SPINNER", spinner);
};
export const hideSpinner = ({ commit }) => {
  commit("HIDE_SPINNER");
};

export const setScrollBlock = ({ commit }, block) => {
  commit("SET_SCROLL_BLOCK", block);
};
export const setPositionScrollY = ({ commit }, positionY) => {
  commit("SET_POSITION_SCROLL_Y", positionY);
};

export const showNotification = ({ commit }, data) => {
  commit("SHOW_NOTIFICATION", data);
};
export const hideNotification = ({ commit }) => {
  commit("HIDE_NOTIFICATION");
};

export const showModal = ({ commit }, type) => {
  commit("SHOW_MODAL", type);
};
export const hideModal = ({ commit }) => {
  commit("HIDE_MODAL");
};

export const clearData = ({ dispatch }) => {
  dispatch("user/clearUser", null, { root: true });
  dispatch("stream/clearStreams", null, { root: true });
};

export const checkConnection = ({ commit }) => {
  commit("STATE_CONNECTION", navigator.onLine);

  window.addEventListener("online", () => {
    commit("STATE_CONNECTION", navigator.onLine);
  });

  window.addEventListener("offline", () => {
    commit("STATE_CONNECTION", navigator.onLine);
  });
};
